import { render } from "./LivescoringSC.vue?vue&type=template&id=3f50e73c&scoped=true"
import script from "./LivescoringSC.vue?vue&type=script&lang=js"
export * from "./LivescoringSC.vue?vue&type=script&lang=js"

import "./LivescoringSC.vue?vue&type=style&index=0&id=3f50e73c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f50e73c"]])

export default __exports__